import { differenceInMonths } from 'date-fns';
export const DAYS_IN_WEEK = 7;
const MAX_MONTH_DAYS = 32;
export const getMonthsFromNow = (currentMonth, monthsToShow) => {
    const months = [];
    for (let i = 0; i < monthsToShow; i++) {
        months.push(getMonthFromNow(currentMonth, i));
    }
    return months;
};
export const getMonthFromNow = (currentMonth, monthsFromNow) => {
    return new Date(currentMonth.getFullYear(), currentMonth.getMonth() + monthsFromNow, 1);
};
export const getNumberOfMonths = (monthsToShow, horizontal, noAvailability, minDate, maxDate) => {
    let numberOfMonths = monthsToShow;
    if (!horizontal && noAvailability) {
        numberOfMonths = 1;
    }
    else if (!horizontal && maxDate && minDate) {
        numberOfMonths = differenceInMonths(maxDate, minDate) + 2;
    }
    return numberOfMonths;
};
export const getActiveDays = (date, duration, direction = 'forwards') => {
    if (!date || Math.sign(duration) === -1 || !duration) {
        return [];
    }
    return [...Array(duration)].map((_, index) => {
        const idx = direction === 'forwards' ? index : index * -1;
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() + idx);
    });
};
export const getDaysInMonth = (date) => {
    return (MAX_MONTH_DAYS -
        new Date(date.getFullYear(), date.getMonth(), MAX_MONTH_DAYS).getDate());
};
const days = [
    new Date('August 01, 2021'), // SUNDAY,
    new Date('August 02, 2021'), // MONDAY,
    new Date('August 03, 2021'), // TUESDAY,
    new Date('August 04, 2021'), // WEDNESDAY,
    new Date('August 05, 2021'), // THURSDAY,
    new Date('August 06, 2021'), // FRIDAY,
    new Date('August 07, 2021'), // SATURDAY,
];
export const getDayLabels = (firstWeekDay, locale) => {
    const dayLabels = days.map((day) => new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(day));
    if (firstWeekDay > 0) {
        const end = dayLabels.slice(0, firstWeekDay);
        const start = dayLabels.slice(firstWeekDay);
        return [...start, ...end];
    }
    return dayLabels;
};
export const getOffsetDays = (date, firstWeekDay) => {
    const actualDayIndex = date.getDay();
    return actualDayIndex >= firstWeekDay
        ? actualDayIndex - firstWeekDay
        : DAYS_IN_WEEK - firstWeekDay + actualDayIndex;
};
export const getCalendarMonthLabel = (date, locale) => `${new Intl.DateTimeFormat(locale, { month: 'short' }).format(date)} ${date.getFullYear()}`;
export const getDateKey = (dateObject) => {
    // TODO: I tried to use .toISOString() but the timezone offset was bumping the date back to
    // the day before - maybe we need to use UTC everywhere
    const month = dateObject.getMonth() + 1;
    const date = dateObject.getDate();
    const formattedMonth = month < 10 ? `0${month}` : month;
    const formattedDate = date < 10 ? `0${date}` : date;
    return `${dateObject.getFullYear()}-${formattedMonth}-${formattedDate}`;
};
export const isSameDate = (date1, date2) => Boolean(date1 &&
    date2 &&
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear());
//# sourceMappingURL=calendar.utils.js.map